// extracted by mini-css-extract-plugin
export var container = "related-post-module--container--az0M9";
export var dateFormat = "related-post-module--date-format--Ck-Yo";
export var header = "related-post-module--header--WX4wU";